import { render } from "./BrdcmSettingsForm.vue?vue&type=template&id=753cd244&scoped=true&ts=true"
import script from "./BrdcmSettingsForm.vue?vue&type=script&lang=ts"
export * from "./BrdcmSettingsForm.vue?vue&type=script&lang=ts"

import "./BrdcmSettingsForm.vue?vue&type=style&index=0&id=753cd244&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753cd244"]])

export default __exports__